const CONSTANTS = {
	API_KEY: "API_KEY_CMS_BO",
	REDUX_ACTION: {
		LOGOUT: "LOGOUT",
		REDUX_PRESIST: "REDUX_PRESIST",
	},
	INBOX_DATE_FORMAT: "ddd DD MMM YY",
	LISTING_DATE_FORMAT: "DD/MM/YYYY",
	LAST_UPDATE_FORMAT: "DD/MM/YYYY | LT",
	MESSAGES: {
		CREATED: "Your new item have been successfully added!",
		UPDATED: "Your changes have been successfully saved!",
		ERROR: "Error! An unknown error occurred during file save.",
	},
};

export default CONSTANTS;
